import { useObservable } from '@adornis/functional-lit/stateful.js';
import { useQuery } from '@adornis/functional-lit/use-query.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import type { Person } from '../../users/entities/person.js';
import { getSelectableSchoolIDs } from '../api/getSelectableSchoolIDs.js';

/**
 * {@link getSelectableSchoolIDs} for the logged in user. `null` means the user may pick any school, an array
 * means the school pickers have to be narrowed down to exactly these ids.
 */
export const useSelectableSchoolIDs = (): string[] | null => {
  const user = useObservable(() => currentUser<Person>(), []);
  const { value } = useQuery(() => getSelectableSchoolIDs(user), [user]);
  return value ?? null;
};
